import React from 'react';
import ConDashboard from './ConDashboard';
import { UserProfile } from '../../types';

interface ConPlannerMainProps {
  currentUserProfile: UserProfile | null;
  initialConId?: string | null;
  onClearInitialCon?: () => void;
  isPublicMode?: boolean;
}

const ConPlannerMain = React.memo(function ConPlannerMain({ currentUserProfile, initialConId, onClearInitialCon, isPublicMode = false }: ConPlannerMainProps) {
  return (
    <div className="h-full animate-in fade-in duration-500">
      <ConDashboard 
        currentUserProfile={currentUserProfile} 
        initialConId={initialConId}
        onClearInitialCon={onClearInitialCon}
        isPublicMode={isPublicMode}
      />
    </div>
  );
});

export default ConPlannerMain;
